import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';

@Pipe({
  name: 'ttCurrency',
})
export class TtCurrencyPipe implements PipeTransform {
  transform(
    value: number,
    currencyCode: string = 'GBP',
    display: 'code' | 'symbol' | 'symbol-narrow' | string | boolean = 'symbol',
    locale: string = 'en'
  ): string | null {
    return formatCurrency(
      value,
      locale,
      getCurrencySymbol(currencyCode, 'wide'),
      currencyCode
    );
  }
}
